<template>
  <div class="menu-header-all">
    <List />
  </div>
</template>

<script>

import List from '../../../components/application/administrator/boleto/List.vue'

export default {
  components:{List}
}
</script>
<style>
.header{
  width: 100%;
  background: #272727;
  height: 200px;
}
.menu-header-all {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.h1-text{
  color: white;
  font-size: 20px;
  font-weight: 500;
  padding: 20px;
  width: 100%;
  justify-content: jus;
  display: flex;
  padding-left: 103px;
}
.theme--light.v-data-table {
  background-color: #FFFFFF;
  color: rgba(0, 0, 0, 0.87);
  padding: 10px !important;
}
</style>